// extracted by mini-css-extract-plugin
export default {"app":"Lvq+","wrap":"Lymg","ver":"TwOJ","logoInner":"HZTg"};